import { Suspense } from 'react';

import { Container } from '@grupoboticario/flora-react';
import { nanoid as createUniqueID } from 'nanoid';

import { componentsMapper } from './components-mapper';
import { ComponentType } from './Prismic';
import Styles from './PrismicComponents.styles';

import type { Component as ComponentProps, ComponentBaseConfig } from 'domains/starlink.d';

export const PrismicComponents = ({ components = [] }: { components: Array<ComponentProps> }) => {
  return (
    <Styles.Wrapper>
      {components.map(({ component, options, items }) => {
        const uuid = createUniqueID();
        const Component = componentsMapper[component as keyof typeof componentsMapper];
        const config = options as ComponentBaseConfig & ComponentType;
        const componentItems = items as ComponentType['items'];

        const shouldShowComponent =
          !!Component &&
          ['portal', 'todos'].some((visibilityType) => options.visibility === visibilityType);

        if (!shouldShowComponent) {
          return null;
        }

        return (
          <Styles.Component key={uuid} data-alternate={options.alternateColor ?? false}>
            <Container size='large'>
              <Suspense fallback={<div />}>
                <Component {...config} items={componentItems} component={component} />
              </Suspense>
            </Container>
          </Styles.Component>
        );
      })}
    </Styles.Wrapper>
  );
};
